<template>
  <div>
    <v-container fluid fill-height class="pt-0">
      <v-layout row align-center justify-center>
        <v-card max-width="1280" width="100%" flat>
          <v-layout row class="py-4">
            <!-- SUPPLIER -->
            <v-flex xs4 pr-2  >
              <v-hover>
                <v-card
                  width="100%"
                  class="elevation-2"
                  slot-scope="{ hover }"
                  :to="{
                    name: 'company',
                    params: { id: contract.supplier_company_id },
                  }"
                >
                  <v-card-title class="pb-2">
                    <span class="primary--text">Supplier</span>
                  </v-card-title>

                  <v-card-text class="pt-0">
                    <!-- SUPPLIER NAME -->
                    <h4 class="truncated-text">
                      {{ contract.supplier_company_name }}
                    </h4>
                    <!-- SUPPLIER City and Country + Flag -->
                    <v-label
                      v-if="
                        contract.supplier_affiliate_company &&
                        contract.supplier_affiliate_company.city
                      "
                      >{{
                        contract.supplier_affiliate_company.city.name
                      }}</v-label
                    >
                    <v-label v-else>{{
                      contract.supplier_company.city.name
                    }}</v-label>

                    <v-label
                      v-if="
                        contract.supplier_affiliate_company &&
                        contract.supplier_affiliate_company.country
                      "
                    >
                      <br />
                      <flag
                        style="
                          font-size: 10px;
                          position: relative;
                          top: -1px;
                          margin-right: 4px;
                        "
                        :iso="
                          contract.supplier_affiliate_company.country.iso_code
                        "
                      />
                      {{ contract.supplier_affiliate_company.country.name }}
                    </v-label>
                    <v-label v-else>
                      <br />
                      <flag
                        style="
                          font-size: 10px;
                          position: relative;
                          top: -1px;
                          margin-right: 4px;
                        "
                        :iso="contract.supplier_company.country.iso_code"
                      />
                      {{ contract.supplier_company.country.name }}
                    </v-label>
                  </v-card-text>
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out white text-xs-center v-card--reveal"
                      style="height: 100%; opacity: 1;"
                    >
                      <v-layout row wrap align-center justify-center>
                        <span class="primary--text">
                          <v-icon class="pr-2" small color="primary"
                            >mdi-arrow-right-circle</v-icon
                          >Go to Supplier page
                        </span>
                      </v-layout>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-hover>
            </v-flex>
            <!-- OVERALL PROGRESS OF ALL EXPEDITIONS -->
            <v-flex xs4 pr-2 d-flex >
              <v-card
                class="elevation-2"
                dark
                :color="
                  cardColor(completedExpeditions, real_expeditions.length)
                "
              >
                <v-card-title class="pb-0">
                  <span class="white--text">Overall Progress</span>
                </v-card-title>

                <v-card-text class="pt-0">
                  <v-layout row justify-center align-center>
                    <v-flex xs9>
                      <v-label dark>Expeditions Complete</v-label>
                      <br />
                      <span class="display-1">{{
                        completedExpeditions + "/" + real_expeditions.length
                      }}</span>
                    </v-flex>

                    <v-flex xs3 justify-center align-end class="text-xs-center">
                      <v-progress-circular
                        size="56"
                        :value="expeditionsCompletedPercentage"
                        >{{
                          expeditionsCompletedPercentage
                        }}%</v-progress-circular
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- CUSTOMER -->
            <v-flex xs4 pr-2  >
              <v-hover>
                <v-card
                  width="100%"
                  class="elevation-2"
                  slot-scope="{ hover }"
                  :to="{
                    name: 'company',
                    params: { id: contract.customer_company_id },
                  }"
                >
                  <v-card-title class="pb-2">
                    <span class="primary--text">Customer</span>
                  </v-card-title>

                  <v-card-text class="pt-0">
                    <h4 class="truncated-text">
                      {{ contract.customer_company_name }}
                    </h4>

                    <!-- customer Address 1 -->
                    <!-- <v-label
                    v-if="contract.customer_affiliate_company && contract.customer_affiliate_company.address1"
                  >{{contract.customer_affiliate_company.address1}}</v-label>
                    <v-label v-else>{{contract.customer_company.address1}}</v-label>-->

                    <!-- customer Address 2 -->
                    <!-- <v-label
                    v-if="contract.customer_affiliate_company && contract.customer_affiliate_company.address2"
                  >, {{contract.customer_affiliate_company.address2}}</v-label>
                    <v-label v-else>, {{contract.customer_company.address2}}</v-label>-->

                    <!-- customer City and Country + Flag -->
                    <v-label
                      v-if="
                        contract.customer_affiliate_company &&
                        contract.customer_affiliate_company.city
                      "
                      >{{
                        contract.customer_affiliate_company.city.name
                      }}</v-label
                    >
                    <v-label v-else>{{
                      contract.customer_company.city.name
                    }}</v-label>

                    <!-- customer City and Country + Flag -->
                    <v-label
                      v-if="
                        contract.customer_affiliate_company &&
                        contract.customer_affiliate_company.country
                      "
                    >
                      <br />
                      <flag
                        style="
                          font-size: 10px;
                          position: relative;
                          top: -1px;
                          margin-right: 4px;
                        "
                        :iso="
                          contract.customer_affiliate_company.country.iso_code
                        "
                      />
                      {{ contract.customer_affiliate_company.country.name }}
                    </v-label>
                    <v-label v-else>
                      <br />
                      <flag
                        style="
                          font-size: 10px;
                          position: relative;
                          top: -1px;
                          margin-right: 4px;
                        "
                        :iso="contract.customer_company.country.iso_code"
                      />
                      {{ contract.customer_company.country.name }}
                    </v-label>
                  </v-card-text>
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out white text-xs-center v-card--reveal"
                      style="height: 100%; opacity: 1;"
                    >
                      <v-layout row wrap align-center justify-center>
                        <span class="primary--text">
                          <v-icon class="pr-2" small color="primary"
                            >mdi-arrow-right-circle</v-icon
                          >Go to Customer page
                        </span>
                      </v-layout>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>


          <!-- ON GOING EXPEDITION -->
          <v-flex
            v-if="completedExpeditions < sortedRealExpeditions.length"
            class="pb-5"
          >
            <v-subheader class="pb-0">On-Progress Expedition(s)</v-subheader>
            <v-data-table
              :headers="headers"
              hide-actions
              :items="sortedRealExpeditions"
            >
              <template slot="items" slot-scope="props">
                <expeditionSummaryCard
                  :key="'expedition_' + props.item.id"
                  :expedition="props.item"
                  :expeditionName="contract.name + '.' + props.item.number"
                  v-if="stepsCompleted(props.item) < props.item.steps.length"
                  :completed="false"
                />
              </template>
            </v-data-table>

            <!-- <template v-for="expedition in sortedRealExpeditions">
              <expeditionSummaryCard
                :key="'expedition_'+expedition.id"
                :expedition="expedition"
                :cardName="contract.name+'.'+expedition.number"
                v-if="stepsCompleted(expedition) < expedition.steps.length"
                :completed="false"
              />
            </template>-->
          </v-flex>

          <!-- EXPEDITIONS COMPLETE -->
          <v-flex v-if="completedExpeditions > 0" class="pb-3">
            <v-subheader class="pb-0">Completed Expedition(s)</v-subheader>

            <v-data-table
              :headers="headers"
              hide-actions
              :items="sortedRealExpeditions"
            >
              <template slot="items" slot-scope="props">
                <expeditionSummaryCard
                  :key="'expedition_' + props.item.id"
                  :expedition="props.item"
                  :expeditionName="contract.name + '.' + props.item.number"
                  v-if="stepsCompleted(props.item) == props.item.steps.length"
                  :completed="true"
                />
              </template>
            </v-data-table>

            <!-- <template v-for="expedition in sortedRealExpeditions">
              <expeditionSummaryCard
                :key="'expedition_completed_'+expedition.id"
                :expedition="expedition"
                :cardName="contract.name+'.'+expedition.number"
                v-if="stepsCompleted(expedition) == expedition.steps.length"
                :completed="true"
              />
            </template>-->
          </v-flex>

          <!-- ALL EXPEDITION HAVE BEEN DONE - > You can archive -->
          <v-flex xs12 pt-4>
            <expeditionTimelineGraph
              :contract_name="contract.name"
              :expeditions="sortedRealExpeditions"
            />
          </v-flex>

          <v-flex class="text-xs-center" v-if="contractCompleted()">
            <span>
              <v-icon class="pr-2" color="primary" small>info</v-icon>
              <span v-if="contract.archived"
                >Every shipments has been delivered. This contract is
                archived.</span
              >
              <span v-else>
                Every shipments has been delivered.
                <a
                  class="pl-1"
                  style="text-decoration: underline;"
                  @click="archive()"
                  >You can archive this contract.</a
                >
              </span>
            </span>
          </v-flex>
        </v-card>
      </v-layout>
    </v-container>
    <!-- <json-viewer :value="contract" sort></json-viewer>
    <json-viewer :value="groupedExpeditions" sort></json-viewer>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import icons from "../mixins/icons.js";
import SHOW_CONTRACT_EXPEDITIONS from "../graphql/contracts/show_expeditions.gql";
import JsonViewer from "vue-json-viewer";
import pluralize from "pluralize";
import date from "../mixins/date.js";
import expeditionSummaryCard from "../components/expeditions/expeditionSummaryCard";
import expeditionTimelineGraph from "../components/expeditions/expeditionTimelineGraph";
import ARCHIVE_CONTRACT from "../graphql/contracts/archive.gql";

export default {
  mixins: [icons, date],
  components: { JsonViewer, expeditionSummaryCard, expeditionTimelineGraph },
  data() {
    return {
      pluralize,
      loading: false,
      headers: [
        {
          text: "Expedition",
          sortable: false,
        },
        {
          text: "Shipment Loading",
          sortable: false,
        },
        {
          text: "Logistic Progress",
          sortable: false,
        },
        {
          text: "Next Logistic Step",
          sortable: false,
        },
        {
          text: "Bl Number",
          sortable: false,
        },
        {
          text: "ETD",
          sortable: false,
        },
        {
          text: "ETA",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("contractStore", [
      "contract",
      "real_expeditions",
      "expeditionDocuments",
    ]),
    sortedRealExpeditions() {
      return this.real_expeditions.sort((a, b) => {
        return a.number - b.number;
      });
    },
    groupedExpeditions() {
      // Group expeditions by Non completed expeditions first, then completed ones after.

      let arr_completed = [{ header: "Completed Expedition(s)" }];
      let arr_onprogress = [{ header: "On-Progress Expedition(s)" }];
      let counter = 0;

      if (!sortedRealExpeditions)
        return []

      this.sortedRealExpeditions.forEach((exp) => {
        counter = 0;
        if (exp.steps) {
          exp.steps.forEach((s) => {
            if (s.validated) counter += 1;
          });

          if (counter == exp.steps.length) {
            arr_completed.push(exp);
          } else arr_onprogress.push(exp);
        }
      });

      arr_onprogress = arr_onprogress.concat(arr_completed);

      return arr_onprogress;
    },
    completedExpeditions() {
      let completed_expeditions = 0;
      let step_counter = 0;
      this.real_expeditions.forEach((exp) => {
        step_counter = 0;
        if (exp.steps) {
          exp.steps.forEach((s) => {
            if (s.validated) step_counter += 1;
          });

          if (step_counter == exp.steps.length) {
            completed_expeditions += 1;
          }
        }
      });
      return completed_expeditions;
    },
    expeditionsCompletedPercentage() {
      return this.completedExpeditions
        ? Math.round(
            (this.completedExpeditions / this.real_expeditions.length) * 100
          )
        : 0;
    },
  },
  methods: {
    archive() {
      this.sendMutation("archived", "contract", ARCHIVE_CONTRACT, {
        id: this.contract.id,
      });
    },
    contractCompleted() {
      if (this.contract.status == "pending") return false;

      for (let i in this.contract.expeditions) {
        if (
          !this.contract.expeditions[i].previsional &&
          !this.contract.expeditions[i].done
        )
          return false;
      }
      return true;
    },
    cardColor(value, max) {
      if (value == 0 || value > max) {
        return "error";
      }

      if (value == max) {
        return "ctcGreen";
      }

      return "amber darken-1";
    },
    stepsCompleted(expedition) {
      let completed_steps = 0;

      expedition.steps.forEach((s) => {
        completed_steps += s.validated;
      });
      return completed_steps;
    },
  },
};
</script>
<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
</style>
